import React from "react";
import "../Styles/_OrderRmaInformation.css";
import { Warning } from "./_Icon";

const OrderRmaInformation = ({ currentLanguage, order }) => {
    return (
        order.rma_requests &&
        order.rma_requests.map(rma_request => (
            <div className="rma-container" key={rma_request.ticket_no}>
                <div className="rma-container-label">
                    <Warning fill="#BF0000" />
                    <p>{`${currentLanguage.ORDER_PAGE.RMA.RMA_TITLE} ${rma_request.ticket_no}`}.</p>
                </div>
                <a className="rma-track" href={`${process.env.REACT_APP_RMA_CUSTOMER_STATUS_BASE_URL}?id=${rma_request.public_ticket_id}`} target="_blank">
                    {currentLanguage.ORDER_PAGE.RMA.RMA_VIEW_DETAILS}
                </a>
            </div>
        ))
    );
};

export default OrderRmaInformation;



// WEBPACK FOOTER //
// ./src/views/Order/components/_OrderRmaInformation.jsx